<page-loader *ngIf="!isLoaded"></page-loader>
<div class="app-l-page-wrap home-dashboard-main-container" *ngIf="isLoaded">
    <div class="app-l-main-heading">
        <h2 translate>clientList.orgOwnContent.title</h2>
        <div class="app-l__actions-block">
            <button
                *ngIf="assignedListLoaded"
                (click)="showAssignModal('true')"
                class="app-c-btn app-c-btn--primary-v2 app-c-btn--curve"
                translate>
                <img
                    alt="Assign"
                    src="./assets/img/icons-svg/assign-user-icon.svg" />clientList.assign
            </button>
            <div class="app-c-select" *ngIf="worksheetClicksLoaded">
                <div
                    class="app-c-custom-select"
                    [class.is-open]="isDateRangeOpen"
                    role="combobox"
                    aria-haspopup="listbox"
                    [attr.aria-expanded]="isDateRangeOpen"
                    aria-label="Select date range">
                    <div
                        class="app-c-select-trigger"
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="isDateRangeOpen"
                        aria-label="Select date range"
                        (click)="
                            isDateRangeOpen = !isDateRangeOpen;
                            $event.stopPropagation()
                        "
                        (keydown.enter)="
                            isDateRangeOpen = !isDateRangeOpen;
                            $event.stopPropagation()
                        "
                        (keydown.space)="
                            $event.preventDefault();
                            isDateRangeOpen = !isDateRangeOpen;
                            $event.stopPropagation()
                        ">
                        <img
                            alt="Assign"
                            src="./assets/img/icons-svg/calendarV1.svg" />
                        <span>{{
                            getSelectedDateRangeTitle() | translate
                        }}</span>
                    </div>
                    <ul
                        class="app-c-select-list"
                        *ngIf="isDateRangeOpen"
                        role="listbox"
                        aria-label="Date range options"
                        (click)="$event.stopPropagation()">
                        <li
                            *ngFor="let days of dateRange"
                            [class.is-selected]="
                                dateRangeSelected === days.value
                            "
                            role="option"
                            tabindex="0"
                            [attr.aria-selected]="
                                dateRangeSelected === days.value
                            "
                            (click)="
                                dateRangeSelected = days.value;
                                isDateRangeOpen = false;
                                onRangeChange(true)
                            "
                            (keydown.enter)="
                                dateRangeSelected = days.value;
                                isDateRangeOpen = false;
                                onRangeChange(true)
                            "
                            (keydown.space)="
                                $event.preventDefault();
                                dateRangeSelected = days.value;
                                isDateRangeOpen = false;
                                onRangeChange(true)
                            ">
                            {{ days.title | translate }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="title-section">
        <page-user-event-assign
            *ngIf="showEventAssignModal"
            [eventType]="'orgOwnContent'"
            [selectedUser]="userDetail"
            [disableUserList]="true"
            [disableEventList]="true"
            [cssClass]="'padding-none'"
            class="app-l-modecheck__sidepanel"
            [userList]="userDetail"
            (closeModal)="onCloseOptions($event)"></page-user-event-assign>
    </div>
    <div class="app-l-dashboard__wrap">
        <div class="app-l-dashboard__wrap--left-area">
            <div class="app-l-dashboard__block">
                <div class="app-l-summary__base">
                    <div class="app-l-result-summary">
                        <div class="app-l-result__card-dm">
                            <div class="app-c-card__header">
                                <div class="title-section app-l-card__h-left">
                                    <h2 class="initial-image">
                                        {{ getInitials(userDetail?.fullName) }}
                                    </h2>
                                    <h4>
                                        {{ userDetail?.fullName }}<br />
                                        <p>{{ userDetail?.email }}</p>
                                    </h4>
                                </div>
                            </div>
                            <div class="demo-result-card">
                                <div class="demo-val">
                                    <p translate>clientList.age</p>
                                    <h4>
                                        {{
                                            demographicData?.Age
                                                ? demographicData?.Age
                                                : '-'
                                        }}
                                    </h4>
                                </div>
                                <div class="demo-val">
                                    <p translate>clientList.ethinicity</p>
                                    <h4>
                                        {{
                                            demographicData?.Ethnicity
                                                ? demographicData?.Ethnicity
                                                : '-'
                                        }}
                                    </h4>
                                </div>
                                <div class="demo-val">
                                    <p translate>clientList.gender</p>
                                    <h4>
                                        {{
                                            demographicData?.Gender
                                                ? demographicData?.Gender
                                                : '-'
                                        }}
                                    </h4>
                                </div>
                                <div class="demo-val">
                                    <p translate>clientList.gradLevel</p>
                                    <h4>
                                        {{
                                            demographicData?.GradeLevel
                                                ? demographicData?.GradeLevel
                                                : '-'
                                        }}
                                    </h4>
                                </div>
                                <div class="demo-val">
                                    <p translate>clientList.referredBy</p>
                                    <h4>
                                        {{
                                            demographicData?.Referred
                                                ? demographicData?.Referred
                                                : '-'
                                        }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="app-c-card app-l-chart__card">
				<div class="app-c-card__body">
					<div
						class="app-l-moods__overall"
					>
					<h3 class="app-c-heading--h3">Mood of the day</h3>
						<app-overall-view-moodcheck
							[hideFilter]="true"
							#moodchecOverallViewComp
						></app-overall-view-moodcheck>
					</div>
				</div>
			</div> -->
            </div>
            <div class="app-l-dashboard__block app-l-dsh__sa">
                <div class="app-c-card">
                    <div class="app-l-summary__base">
                        <div class="app-l-result-summary">
                            <div class="app-l-result__card-dm">
                                <div class="app-l-result__card-header">
                                    <h3 class="app-c-heading--h3" translate>
                                        clientList.snapshot
                                        <span class="time-label"
                                            >({{
                                                'clientList.series.allTime'
                                                    | translate
                                            }})</span
                                        >
                                    </h3>
                                </div>
                                <div class="app-l-result__card-body">
                                    <ng-container
                                        *ngIf="!allSeriesLoaded"
                                        [ngTemplateOutlet]="skeletonLoader"
                                        [ngTemplateOutletContext]="{
                                            height: '100px',
                                        }">
                                    </ng-container>
                                    <div class="app-l-count">
                                        <div
                                            class="app-l-completed-assessment"
                                            *ngIf="allSeriesLoaded">
                                            <p translate>
                                                clientList.series.watchedVideosNumber
                                            </p>
                                            <h2 class="count-card">
                                                {{ completedCount }}
                                                <span translate
                                                    >clientList.series.videos</span
                                                >
                                            </h2>
                                        </div>
                                        <div
                                            class="app-l-completed-assessment"
                                            *ngIf="
                                                allSeriesLoaded &&
                                                (user?.primaryOrganization
                                                    ?.enableStory ||
                                                    user?.primaryOrganization
                                                        ?.enableBurningQuestion)
                                            ">
                                            <p translate>
                                                clientList.series.watchedVoiceNumber
                                            </p>
                                            <h2
                                                class="count-card"
                                                *ngIf="
                                                    user?.primaryOrganization
                                                        ?.enableStory
                                                ">
                                                {{ storiesCount }}
                                                <span translate
                                                    >clientList.series.stories</span
                                                >
                                            </h2>
                                            <h2
                                                class="count-card"
                                                *ngIf="
                                                    user?.primaryOrganization
                                                        ?.enableBurningQuestion
                                                ">
                                                {{ burningQuestionCount }}
                                                <span translate
                                                    >clientList.series.burningQuestion</span
                                                >
                                            </h2>
                                        </div>
                                        <div
                                            class="app-l-completed-assessment"
                                            *ngIf="allSeriesLoaded">
                                            <p translate>No. of Reads</p>
                                            <h2 class="count-card">
                                                {{ readsCount }}
                                                <span translate
                                                    >clientList.series.reads</span
                                                >
                                            </h2>
                                        </div>
                                    </div>
                                    <div class="app-l-latest-videos">
                                        <p translate>
                                            clientList.series.latestVideos
                                        </p>
                                        <ng-container
                                            *ngIf="!latestVideoLoaded"
                                            [ngTemplateOutlet]="skeletonLoader"
                                            [ngTemplateOutletContext]="{
                                                height: '100px',
                                            }">
                                        </ng-container>
                                        <div *ngIf="latestVideoLoaded">
                                            <div
                                                class="app-l-latest-videos-list"
                                                *ngIf="latestVideos.length > 0">
                                                <div
                                                    class="additional-val"
                                                    *ngFor="
                                                        let video of latestVideos
                                                    ">
                                                    <div
                                                        class="app-l-img-holder">
                                                        <img
                                                            [defaultImage]="'./assets/img/course_image_default.svg'"
                                                            [lazyLoad]="
                                                                video[0]
                                                                    .ImagePath
                                                            " />
                                                    </div>
                                                    <div class="app-l-details">
                                                        <div
                                                            class="badge completed"
                                                            *ngIf="
                                                                video[0]
                                                                    .Status ===
                                                                'completed'
                                                            "
                                                            translate>
                                                            <svg-icon
                                                                icon="completed"></svg-icon>
                                                            clientList.series.completed
                                                        </div>
                                                        <div
                                                            class="badge in-progress"
                                                            *ngIf="
                                                                video[0]
                                                                    .Status ===
                                                                'inprogress'
                                                            "
                                                            translate>
                                                            <svg-icon
                                                                icon="in-progress"></svg-icon>
                                                            clientList.series.inProgress
                                                        </div>
                                                        <div
                                                            class="badge not-started"
                                                            *ngIf="
                                                                video[0]
                                                                    .Status ===
                                                                'notStarted'
                                                            "
                                                            translate>
                                                            <svg-icon
                                                                icon="not-started"></svg-icon>
                                                            clientList.series.notStarted
                                                        </div>
                                                        <p>
                                                            {{ video[0].Label }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                class="app-l-latest-videos-list"
                                                *ngIf="
                                                    latestVideos.length == 0
                                                ">
                                                <p class="center" translate>
                                                    clientList.series.noLatestVideos
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="app-l-result__card app-l-assessment-assignments">
                <div class="app-l-result__card-header">
                    <div class="app-l-result__card-header-left">
                        <h3 class="app-c-heading--h3" translate>
                            clientList.series.title
                            <span class="time-label"
                                >({{
                                    'clientList.series.allTime' | translate
                                }})</span
                            >
                        </h3>
                    </div>
                    <div
                        class="app-l-result__card-header-right"
                        *ngIf="assignedListLoaded">
                        <!-- <a class="action-view" routerLink="" translate
                            >View All</a
                        > -->
                        <button
                            class="app-c-btn app-c-btn--primary-v2 app-c-btn--curve"
                            (click)="showAssignModal('true')"
                            translate>
                            <img
                                alt="Assign"
                                src="./assets/img/icons-svg/assign-user-icon.svg" />
                            <span translate>clientList.assign</span>
                        </button>
                    </div>
                </div>

                <div class="app-l-result__card-body">
                    <div class="app-l-result-item__base">
                        <div class="app-l-result-item__card-block">
                            <ng-container
                                *ngIf="!assignedListLoaded"
                                [ngTemplateOutlet]="skeletonLoader"
                                [ngTemplateOutletContext]="{ height: '100px' }">
                            </ng-container>
                            <my-tabs
                                *ngIf="assignedListLoaded"
                                #tabGroup
                                (tabChange)="onTabChanged($event)">
                                <!-- Tab 1: Basic Details -->
                                <my-tab [tabTitle]="'Assigned'">
                                    <!-- <div class="app-c-card"> -->
                                    <div
                                        class="app-c-card__body assignment-list">
                                        <div
                                            class="app-l-dsh__rp-wrap"
                                            *ngIf="
                                                assignmentList?.assigned
                                                    .length > 0
                                            ">
                                            <div
                                                tabindex="0"
                                                class="app-l-dsh__rp-card"
                                                *ngFor="
                                                    let assignment of assignmentList?.assigned
                                                ">
                                                <div
                                                    class="app-l-latest-videos-list">
                                                    <div class="additional-val">
                                                        <div
                                                            class="app-l-img-holder">
                                                            <img
                                                                [defaultImage]="'./assets/img/course_image_default.svg'"
                                                                [lazyLoad]="
                                                                    assignment.ImagePath
                                                                        ? assignment.ImagePath
                                                                        : './assets/img/course_image_default.svg'
                                                                " />
                                                        </div>
                                                        <div
                                                            class="app-l-details">
                                                            <div
                                                                class="app-l-badge-wrapper">
                                                                <!-- <div
                                                                    class="badge completed"
                                                                    *ngIf="
                                                                        assignment.status
                                                                    ">
                                                                    <svg-icon
                                                                        icon="completed"></svg-icon>
                                                                    Completed
                                                                </div> -->
                                                                <div
                                                                    class="badge in-progress"
                                                                    *ngIf="
                                                                        assignment.status
                                                                    "
                                                                    translate>
                                                                    <svg-icon
                                                                        icon="in-progress"></svg-icon>
                                                                    clientList.series.inProgress
                                                                </div>
                                                                <div
                                                                    class="badge not-started"
                                                                    *ngIf="
                                                                        !assignment.status
                                                                    "
                                                                    translate>
                                                                    <svg-icon
                                                                        icon="not-started"></svg-icon>
                                                                    clientList.series.notStarted
                                                                </div>
                                                                <span>
                                                                    <div
                                                                        class="icon">
                                                                        <svg-icon
                                                                            icon="time"></svg-icon>
                                                                    </div>
                                                                    <span>
                                                                        {{
                                                                            assignment.Date
                                                                                | date
                                                                                    : 'MMM dd, yyyy'
                                                                        }}
                                                                    </span>
                                                                </span>
                                                                <div>
                                                                    <button
                                                                        tabindex="0"
                                                                        class="app-c-btn app-c-btn--icon-primary app-c-btn--icon app-c-btn--icon-20"
                                                                        (click)="
                                                                            deleteAssign(
                                                                                assignment.ID
                                                                            )
                                                                        "
                                                                        (keypress)="
                                                                            deleteAssign(
                                                                                assignment.ID
                                                                            )
                                                                        ">
                                                                        <svg-icon
                                                                            icon="trash"
                                                                            class="w-100 h-100"
                                                                            alt="trash"></svg-icon>
                                                                    </button>
                                                                </div>
                                                            </div>

                                                            <p>
                                                                {{
                                                                    assignment.Name
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="app-l-dsh__rp-wrap center"
                                            *ngIf="
                                                assignmentList?.assigned
                                                    .length == 0
                                            "
                                            translate>
                                            clientList.series.noPendingAssignment
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                </my-tab>

                                <my-tab [tabTitle]="'Completed'">
                                    <!-- <div class="app-c-card"> -->
                                    <div
                                        class="app-c-card__body assignment-list">
                                        <div
                                            class="app-l-dsh__rp-wrap"
                                            *ngIf="
                                                assignmentList?.completed
                                                    .length > 0
                                            ">
                                            <div
                                                tabindex="0"
                                                class="app-l-dsh__rp-card"
                                                *ngFor="
                                                    let assignment of assignmentList?.completed
                                                ">
                                                <div
                                                    class="app-l-latest-videos-list">
                                                    <div class="additional-val">
                                                        <div
                                                            class="app-l-img-holder">
                                                            <img
                                                                [defaultImage]="'./assets/img/course_image_default.svg'"
                                                                [lazyLoad]="
                                                                    assignment.ImagePath
                                                                        ? assignment.ImagePath
                                                                        : './assets/img/course_image_default.svg'
                                                                " />
                                                        </div>
                                                        <div
                                                            class="app-l-details">
                                                            <div
                                                                class="app-l-badge-wrapper">
                                                                <div
                                                                    class="badge completed"
                                                                    translate>
                                                                    <svg-icon
                                                                        icon="completed"></svg-icon>
                                                                    clientList.series.completed
                                                                </div>
                                                                <span>
                                                                    <div
                                                                        class="icon">
                                                                        <svg-icon
                                                                            icon="time"></svg-icon>
                                                                    </div>
                                                                    <span>
                                                                        {{
                                                                            assignment.UpdatedOnUtc
                                                                                | date
                                                                                    : 'dd MMMM YYYY'
                                                                        }}
                                                                    </span>
                                                                </span>
                                                            </div>

                                                            <p>
                                                                {{
                                                                    assignment.Name
                                                                }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="app-l-dsh__rp-wrap center"
                                            *ngIf="
                                                assignmentList?.completed
                                                    .length == 0
                                            "
                                            translate>
                                            clientList.series.noCompletedAssignment
                                        </div>
                                    </div>
                                    <!-- </div> -->
                                </my-tab>
                            </my-tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="app-l-dashboard__wrap--right-area">
            <div class="app-l-dashboard__block app-l-video-series-warper">
                <div class="app-c-card__header">
                    <h3 class="app-l-card__title" translate>
                        clientList.series.allVideoSeries
                        <span class="time-label"
                            >({{
                                'clientList.series.allTime' | translate
                            }})</span
                        >
                    </h3>
                    <div class="app-l-card__h-right">
                        <!-- <a
                            class="action-view"
                            (click)="viewAllSeries()"
                            translate
                            >menu.viewAll</a
                        > -->
                    </div>
                </div>
                <ng-container
                    *ngIf="!allSeriesLoaded"
                    [ngTemplateOutlet]="skeletonLoader"
                    [ngTemplateOutletContext]="{
                        height: '100px',
                    }">
                </ng-container>
                <div class="app-c-card__body" *ngIf="allSeriesLoaded">
                    <div class="app-l-dashboard-course">
                        <div class="app-l-dc__body">
                            <div class="app-l-dc__course-row series-list">
                                <div
                                    tabindex="0"
                                    class="app-l-dc__c-block"
                                    *ngFor="
                                        let course of recommendedcourses[0]
                                    ">
                                    <div
                                        class="app-l-dc__c-over"
                                        *ngIf="course.Enabled">
                                        <div
                                            class="app-l-completed-date inprogress"
                                            *ngIf="
                                                course.courseprogress ===
                                                'inprogress'
                                            ">
                                            <div class="icon">
                                                <svg-icon
                                                    icon="progress"></svg-icon>
                                            </div>
                                            <span translate
                                                >clientList.series.inProgress</span
                                            >
                                        </div>
                                        <div
                                            class="app-l-completed-date completed"
                                            *ngIf="
                                                course.completedcount ==
                                                    course.videoCount &&
                                                course.completed
                                            ">
                                            <div class="icon">
                                                <svg-icon
                                                    icon="tickIcon"></svg-icon>
                                            </div>
                                            <span
                                                >{{
                                                    'clientList.series.completedOn'
                                                        | translate
                                                }}
                                                {{
                                                    course.completedon
                                                        | date: 'DD MMM YYYY'
                                                }}</span
                                            >
                                        </div>
                                        <div class="app-l-dc__c-image">
                                            <img
                                                [defaultImage]="'../../../../assets/img/dashboard/no-image.svg'"
                                                [lazyLoad]="course.CourseImage"
                                                alt="view-more-button" />
                                            <!-- <button
                                                class="app-l-dc__play"
                                                (click)="
                                                    gotoSeries(course.Key)
                                                ">
                                                <svg-icon
                                                    icon="play"
                                                    alt="play"
                                                    class="w-100 h-100"></svg-icon>
                                            </button> -->
                                        </div>

                                        <div class="app-l-dc__c-content">
                                            <h2 class="app-c-body-text--16-m">
                                                {{ course.Name }}
                                            </h2>
                                            <!-- <div class="app-l-dc__c-info-box">
                                                <div class="app-l-dc__c-info">
                                                    <span
                                                        class="app-l-dc__cat"
                                                        translate
                                                        >{{
                                                            'dashboard.' +
                                                                course.cardType
                                                        }}</span
                                                    >
                                                </div>
                                            </div> -->
                                        </div>
                                        <div class="app-l-footer">
                                            <div class="app-l-footer_completed">
                                                <span translate
                                                    >clientList.series.completed</span
                                                >
                                                <div class="badge">
                                                    {{
                                                        course.completed
                                                            ? course.completedcount
                                                            : 0
                                                    }}
                                                </div>
                                            </div>
                                            <div class="app-l-footer_pending">
                                                <span translate
                                                    >clientList.series.pending</span
                                                >
                                                <div class="badge">
                                                    {{
                                                        course.videoCount -
                                                            course.completedcount
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="app-l-dashboard__block app-l-video-series-warper app-l-audio-series-tab">
                <div class="app-c-card__header">
                    <h3 class="app-l-card__title">
                        {{ 'clientList.series.allAudioSeries' | translate }}
                        <span class="time-label"
                            >({{
                                'clientList.series.allTime' | translate
                            }})</span
                        >
                    </h3>
                    <div class="app-l-card__h-right">
                        <!-- <a
                            class="action-view"
                            (click)="viewAllSeries()"
                            translate
                            >menu.viewAll</a
                        > -->
                    </div>
                </div>
                <my-tabs #tabGroup (tabChange)="onTabChangedList($event)">
                    <my-tab>
                        <ng-template #myTabTitle>
                            <span translate
                                >clientList.series.voiceStories</span
                            >
                        </ng-template>
                        <ng-container
                            *ngIf="!allSeriesLoaded"
                            [ngTemplateOutlet]="skeletonLoader"
                            [ngTemplateOutletContext]="{
                                height: '100px',
                            }">
                        </ng-container>

                        <div class="app-c-card__body" *ngIf="allSeriesLoaded">
                            <div class="app-l-dashboard-course">
                                <div class="app-l-dc__body">
                                    <div
                                        class="app-l-dc__course-row series-list">
                                        <div
                                            tabindex="0"
                                            class="app-l-dc__c-block"
                                            *ngFor="let story of storyList">
                                            <div class="app-l-dc__c-over">
                                                <div
                                                    class="app-l-completed-date inprogress"
                                                    *ngIf="
                                                        story?.courseProgress
                                                            ?.Status ===
                                                        'inprogress'
                                                    ">
                                                    <div class="icon">
                                                        <svg-icon
                                                            icon="progress"></svg-icon>
                                                    </div>
                                                    <span translate
                                                        >clientList.series.inProgress</span
                                                    >
                                                </div>
                                                <div
                                                    class="app-l-completed-date completed"
                                                    *ngIf="
                                                        story?.courseProgress
                                                            ?.Status ===
                                                        'completed'
                                                    ">
                                                    <div class="icon">
                                                        <svg-icon
                                                            icon="tickIcon"></svg-icon>
                                                    </div>
                                                    <span translate
                                                        >clientList.series.completed</span
                                                    >
                                                </div>
                                                <div
                                                    class="series-type-card type-allen">
                                                    <div
                                                        class="app-l-dc__c-image-story">
                                                        <img
                                                            [defaultImage]="'../../../assets/img/series/voice-stories-bg.svg'"
                                                            [lazyLoad]="
                                                                story.imageUrl
                                                            " />
                                                    </div>
                                                    <!-- <div class="app-l-dc__c-content"> -->
                                                    <div
                                                        class="card-content-story"
                                                        translate>
                                                        {{
                                                            story
                                                                ? story[
                                                                      'title_' +
                                                                          lang
                                                                  ]
                                                                : ''
                                                        }}
                                                        <span>{{
                                                            story
                                                                ? story[
                                                                      'author_' +
                                                                          lang
                                                                  ]
                                                                : ''
                                                        }}</span>
                                                    </div>
                                                </div>
                                                <div class="app-l-footer">
                                                    <div
                                                        class="app-l-footer_completed">
                                                        <span translate
                                                            >clientList.series.totalPlay</span
                                                        >
                                                        <div class="badge">
                                                            {{
                                                                story
                                                                    ?.courseProgress
                                                                    ?.ViewCount ??
                                                                    0
                                                            }}
                                                        </div>
                                                    </div>
                                                    <!-- <div class="app-l-footer_pending">
                                                        <span translate>clientList.series.pending</span>
                                                        <div class="badge">
                                                            {{
                                                            story.videoCount -
                                                            story.completedcount
                                                            }}
                                                        </div>
                                                    </div> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </my-tab>
                    <my-tab>
                        <ng-template #myTabTitle>
                            <span translate
                                >clientList.series.voiceburningQuestion</span
                            >
                        </ng-template>
                        <ng-container
                            *ngIf="!allSeriesLoaded"
                            [ngTemplateOutlet]="skeletonLoader"
                            [ngTemplateOutletContext]="{
                                height: '100px',
                            }">
                        </ng-container>
                        <div class="app-c-card__body" *ngIf="allSeriesLoaded">
                            <div class="app-l-dashboard-course">
                                <div class="app-l-dc__body series-list-bq">
                                    <ng-container
                                        *ngFor="
                                            let category of burningQuestionList
                                        ">
                                        <!-- <div
                                            class="app-l-burning-questions-holder_items">
                                            <div
                                                class="app-l-burning-questions-holder_heading"
                                                translate>
                                                <img
                                                    class="bq-icon-img"
                                                    [defaultImage]=""
                                                    [lazyLoad]="
                                                        '../../../assets/img/series/bq-category-icons/bq_' +
                                                        category.categoryKey +
                                                        '.svg'
                                                    " />
                                                {{
                                                    'series.categories.' +
                                                        category.categoryKey
                                                }}
                                            </div>
                                        </div> -->
                                        <div class="app-l-dc__course-row">
                                            <div
                                                tabindex="0"
                                                class="app-l-dc__c-block"
                                                *ngFor="
                                                    let bqlist of category?.data
                                                ">
                                                <div class="app-l-dc__c-over">
                                                    <div
                                                        class="app-l-completed-date inprogress"
                                                        *ngIf="
                                                            bqlist
                                                                ?.courseProgress
                                                                ?.Status ===
                                                            'inprogress'
                                                        ">
                                                        <div class="icon">
                                                            <svg-icon
                                                                icon="progress"></svg-icon>
                                                        </div>
                                                        <span translate
                                                            >clientList.series.inProgress</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="app-l-completed-date completed"
                                                        *ngIf="
                                                            bqlist
                                                                ?.courseProgress
                                                                ?.Status ===
                                                            'completed'
                                                        ">
                                                        <div class="icon">
                                                            <svg-icon
                                                                icon="tickIcon"></svg-icon>
                                                        </div>
                                                        <span translate
                                                            >clientList.series.completed</span
                                                        >
                                                    </div>
                                                    <div
                                                        class="series-type-card type-allen">
                                                        <div
                                                            class="app-l-dc__c-image-bq">
                                                            <img
                                                                [defaultImage]="'../../../assets/img/series/voice-bq-default.svg'"
                                                                [lazyLoad]="
                                                                    bqlist.imageUrl
                                                                " />
                                                        </div>
                                                        <!-- <div class="app-l-dc__c-content"> -->
                                                        <div
                                                            class="card-content-bq"
                                                            translate>
                                                            {{
                                                                bqlist
                                                                    ? bqlist[
                                                                          'title_' +
                                                                              lang
                                                                      ]
                                                                    : ''
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="app-l-footer">
                                                        <div
                                                            class="app-l-footer_completed">
                                                            <span translate
                                                                >clientList.series.totalPlay</span
                                                            >
                                                            <div class="badge">
                                                                {{
                                                                    bqlist
                                                                        ?.courseProgress
                                                                        ?.ViewCount ??
                                                                        0
                                                                }}
                                                            </div>
                                                        </div>
                                                        <!-- <div class="app-l-footer_pending">
                                                            <span translate>clientList.series.pending</span>
                                                            <div class="badge">
                                                                {{
                                                                story.videoCount -
                                                                story.completedcount
                                                                }}
                                                            </div>
                                                        </div> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </my-tab>
                    <my-tab>
                        <ng-template #myTabTitle>
                            <span translate>clientList.series.reads</span>
                        </ng-template>
                        <ng-container
                            *ngIf="!allSeriesLoaded"
                            [ngTemplateOutlet]="skeletonLoader"
                            [ngTemplateOutletContext]="{
                                height: '100px',
                            }">
                        </ng-container>
                        <div
                            class="app-c-card__body"
                            *ngIf="allSeriesLoaded && readsList.length > 0">
                            <div class="app-l-dashboard-course">
                                <div class="app-l-dc__body">
                                    <div
                                        class="app-l-dc__course-row series-list">
                                        <div
                                            tabindex="0"
                                            *ngFor="let item of readsList">
                                            <!-- <div class="app-l-dc__c-over">
                                                <div class="series-type-card type-allen"> -->
                                            <div class="series-type-card">
                                                <div
                                                    class="cover-image-section readable-section">
                                                    <img
                                                        [defaultImage]="'../../../../assets/img/series/reads-default.svg'"
                                                        [lazyLoad]="
                                                            item['thumbnailUrl']
                                                                ? item.thumbnailUrl
                                                                : '../../../../assets/img/series/reads-default.svg'
                                                        " />
                                                    <div class="card-content">
                                                        <h2
                                                            class="app-l-course__title">
                                                            {{
                                                                item[
                                                                    'title' +
                                                                        lang
                                                                ]
                                                            }}
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="app-c-card__body-daily"
                            *ngIf="readsList.length === 0">
                            <div class="app-l-dsh__sa-card" translate>
                                clientList.overview.noRecentSeries
                            </div>
                        </div>
                    </my-tab>
                </my-tabs>
            </div>

            <div class="app-l-dashboard__block app-l-exercise-warper">
                <div class="app-c-card__header">
                    <h3 translate>clientList.series.worksheetClicks</h3>
                </div>
                <ng-container
                    *ngIf="!worksheetClicksLoaded"
                    [ngTemplateOutlet]="skeletonLoader"
                    [ngTemplateOutletContext]="{
                        height: '100px',
                    }">
                </ng-container>
                <div class="app-c-card__body" *ngIf="worksheetClicksLoaded">
                    <div
                        class="app-l-dsh__sa-wrap"
                        *ngIf="workSheetData.length > 0">
                        <div
                            class="app-l-dsh__sa-card"
                            *ngFor="let workSheet of workSheetData">
                            <h5>{{ workSheet.Title }}</h5>
                            <h3>
                                {{ workSheet.clickcount }}
                                <span translate>clientList.series.clicks</span>
                            </h3>
                            <div class="app-l-sa__time">
                                Last {{ dateRangeSelected }} days
                            </div>
                        </div>
                    </div>
                    <div
                        class="center"
                        style="margin-bottom: 20px"
                        *ngIf="workSheetData.length == 0"
                        translate>
                        clientList.series.noWorksheetData
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template let-height="height" #skeletonLoader>
    <div class="app-c-card">
        <span class="app-c-spinner" aria-label="Loading"></span>
    </div>
</ng-template>
